export const BASE_URL = process.env.VUE_APP_BASE_URL;
export const TICKET_URL = process.env.VUE_APP_TICKET_URL;
export const SUB_BASE_URL = process.env.VUE_APP_SUB_BASE_URL;
export const SERVICE_URL = process.env.VUE_APP_SERVICE_URL;
export const TFW_HOST_URL = process.env.VUE_APP_TFW_HOST;
export const JGM_URL = process.env.VUE_APP_JGM_URL;
export const HOST = process.env.VUE_APP_HOST
